module.exports = __webpack_public_path__ + "img/plus-circle.6313c624.svg";